import WebPageLayout from "../../../../../layouts/WebPageLayout";
import ManagePageLayout from "../../../../../layouts/ManagePageLayout";
import React from "react";
import {ScreenProps} from "../../../../../../../utils/screen-props-helper";
import useEntityManagePage from "../../../../../hooks/useEntityManagePage";
import {
  useCreateFallOutMutation, useLazyGetFallOutQuery,
  useUpdateFallOutMutation
} from "../../../../../../../store/services/api/fall-out-api";
import { FallOutStackParamList } from "../../fallOutStack";
import FallOutManageForm from "./components/fallOutManageForm";

export default function FallOutManageScreen({route}: ScreenProps<FallOutStackParamList, 'manage'>) {
  const {
    entity,
    onSubmit
  } = useEntityManagePage({
    entityName: "FallOut",
    entityId: route?.params?.id,
    createMutation: useCreateFallOutMutation,
    updateMutation: useUpdateFallOutMutation,
    lazyGetEntityQuery: useLazyGetFallOutQuery
  })

  return (
    <WebPageLayout header={{
      previousTab: {title: 'Fault Code', routeName: 'list'},
      tabs: [
        {title: 'Manage Fault Code', routeName: 'manage'}
      ]
    }}>
      <ManagePageLayout>
        <FallOutManageForm fallOut={entity} onSubmit={onSubmit}/>
      </ManagePageLayout>
    </WebPageLayout>
  )
}
